import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Text, Title } from '@carnica/ui-kit';
import { IconInfoOutline } from '@carnica/graphics';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { tariff } from "../../../constants/tariff";
import { getFormattedCtn } from "../../../utils";
import styles from "./styles.pcss";
import { selectParentInfo, selectSharingList } from "../store";
import { Tag } from "../Tag";
var cn = classNames.bind(styles);
var _InfoTag = function _InfoTag(_ref) {
  var _parentInfo$;
  var parentInfo = _ref.parentInfo,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var handleModalClose = function handleModalClose() {
    setOpen(false);
  };
  var handleModalOpen = function handleModalOpen(e) {
    e.preventDefault();
    setOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!(children !== null && children !== void 0 && children.length) && /*#__PURE__*/React.createElement(Tag, {
    isExtended: true,
    list: children,
    "data-t-id": "MobileTariff-InfoTag"
  }, tariff.sharingText.master), !!(parentInfo !== null && parentInfo !== void 0 && parentInfo.length) && /*#__PURE__*/React.createElement(Button, {
    className: cn('extended'),
    mode: "inline",
    onClick: handleModalOpen,
    view: "secondary"
  }, /*#__PURE__*/React.createElement(Tag, {
    list: parentInfo,
    "data-t-id": "MobileTariff-InfoTag"
  }, "".concat(tariff.sharingText.slave, " ").concat(getFormattedCtn((_parentInfo$ = parentInfo[0]) === null || _parentInfo$ === void 0 ? void 0 : _parentInfo$.ctn)), /*#__PURE__*/React.createElement(IconInfoOutline, {
    color: "primary",
    size: 20,
    "data-t-id": "MobileTariff-InfoTag"
  }))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: handleModalClose
  }, /*#__PURE__*/React.createElement(Title, {
    className: cn('title'),
    size: "xl",
    title: tariff.unifiedTariff.title,
    "data-t-id": "MobileTariff-InfoTag"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "m"
  }, tariff.unifiedTariff.text)), /*#__PURE__*/React.createElement(Button, {
    onClick: handleModalClose,
    width: useIsMobileDimension() ? 'full' : 'default'
  }, tariff.unifiedTariff.btnText)));
};
var mapStateToProps = function mapStateToProps(state) {
  var children = selectSharingList(state);
  var parentInfo = selectParentInfo(state);
  return {
    shouldRender: !!(children !== null && children !== void 0 && children.length) || !!(parentInfo !== null && parentInfo !== void 0 && parentInfo.length),
    children: children,
    parentInfo: parentInfo
  };
};
export var InfoTag = compose(connect(mapStateToProps), withRenderFlag)(_InfoTag);